import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Router } from 'react-router-dom';
import './config/ReactotronConfig';
import AppRoutes from './routes';
import history from './services/history';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
import styles from './components/Style/global.module.css'
import { WrapperProvider } from './context/WrapperContext';
import { AuthProvider } from "./context/AuthContext";
import { AppearanceProvider } from './context/AppearanceContext';

function App() {
  return (
    <>
      <AppearanceProvider>
        <div className={styles.app}>
          <AuthProvider>
            <WrapperProvider>
              <AppRoutes />
              <ToastContainer
                autoClose={10000}
                position="bottom-left"
                hideProgressBar={false}
                closeButton={true}
                style={{ opacity: .9 }}
              />
            </WrapperProvider>
          </AuthProvider>
        </div>
      </AppearanceProvider>
    </>
  );
}

export default App;
